import React from 'react';
import { Navigate } from 'react-router-dom';
import { MainLayout } from '@/components/layout/MainLayout';
import { PersonalizedDashboard } from '@/components/dashboard/PersonalizedDashboard';
import { CorporateDashboard } from '@/components/dashboard/CorporateDashboard';
import { ProjectDeveloperDashboard } from '@/components/dashboard/ProjectDeveloperDashboard';
import { useAuth } from '@/components/AuthProvider';

const Dashboard = () => {
  const { user, profile } = useAuth();

  // Redirect to home if not authenticated
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Route to appropriate dashboard based on user type
  const renderDashboard = () => {
    const userType = profile?.user_type;
    
    if (userType === 'project_developer') {
      // Redirect project developers to their dedicated dashboard
      return <Navigate to="/project-developer" replace />;
    } else if (userType === 'entity') {
      return <CorporateDashboard />;
    } else {
      // Default to corporate dashboard if no specific type
      return <CorporateDashboard />;
    }
  };

  return (
    <MainLayout>
      {renderDashboard()}
    </MainLayout>
  );
};

export default Dashboard;